module.exports = __webpack_public_path__ + "img/img31.5a932624.svg";